export default {
  calculateTotalPrice(order) {
    let totalPrice = 0.0;
    const items = order.items === undefined ? [] : order.items;

    for (let i = 0; i < items.length; i += 1) {
      const item = items[i];
      totalPrice += item.total_price.cents;
    }

    totalPrice += order.shipping_total.cents;
    totalPrice += order.tax_total.cents;

    return totalPrice;
  },

  getSalesOrderItems(order) {
    const salesOrderItems = [];
    const items = order.items === undefined ? [] : order.items;
    items.forEach((item) => {
      if(!item.product_attributes.name && item.product_attributes.description) {
        item.product_attributes.name = {};
        item.product_attributes.name.en = item.product_attributes.description.en;
      }
      const name = item.product_attributes.name ? item.product_attributes.name.en : '';
      const availability = item.product_attributes.details.en[`Availability_${item.sku}`] ? item.product_attributes.details.en[`Availability_${item.sku}`][0] : '';
      salesOrderItems.push({
        '_id': item._id,
        sku: item.sku,
        quantity: item.quantity,
        description: name,
        availability_text: availability,
        price_adjustments: item.price_adjustments ? item.price_adjustments.map( (pa) => {
          pa.data.original_price = Number(pa.data.original_price);
          return pa;
        }) : [],
        total_price: item.total_price,
        blank_item: item.blank_item,
      });
    });

    return salesOrderItems.reverse();
  },

  cleanSalesOrderItems(order) {
    return order.salesOrderItems.map((item) => {
      return item.price_adjustments = item.price_adjustments.map((adj) => {
        delete adj.isRootInsert;
        return adj;
      });
    });
  },

  getPaymentMethod(payment, order) {
    const paymentMethod = {
      paymentTerms: '',
      poNumber: '',
      amount: 0,
      paymentObject: {},
    };

    if (Object.prototype.hasOwnProperty.call(payment, 'credit_card')) {
      paymentMethod.paymentTerms = 'credit_card';
      paymentMethod.paymentObject = payment.credit_card;
    } else if (Object.prototype.hasOwnProperty.call(payment, 'purchase_order')) {
      paymentMethod.paymentTerms = 'purchase_order';
      paymentMethod.poNumber = order.po_number;
      paymentMethod.paymentObject = payment.purchase_order;
    } else if (order.quote) {
      paymentMethod.paymentTerms = 'quote';
      paymentMethod.paymentObject = payment.quote;
    } else if (Object.prototype.hasOwnProperty.call(payment, 'check_by_mail')) {
      paymentMethod.paymentTerms = 'check_by_mail';
      paymentMethod.paymentObject = payment.check_by_mail;
    } else if (Object.prototype.hasOwnProperty.call(payment, 'wire_transfer')) {
      paymentMethod.paymentTerms = 'wire_transfer';
      paymentMethod.paymentObject = payment.wire_transfer;
    } else if (Object.prototype.hasOwnProperty.call(payment, 'gift_card')) {
      paymentMethod.paymentTerms = 'gift_card';
      paymentMethod.paymentObject = payment.gift_card;
    } else if (Object.prototype.hasOwnProperty.call(payment, 'store_credit')) {
      paymentMethod.paymentTerms = 'store_credit';
      paymentMethod.paymentObject = payment.store_credit;
    } else {
      console.warn('No Payment method found', payment);
      paymentMethod.paymentTerms = 'unknown';
    }

    if(paymentMethod.paymentObject) {
      paymentMethod.originalTerms = paymentMethod.paymentTerms;
      paymentMethod.amount = paymentMethod.paymentObject.amount.cents / 100;

      return paymentMethod;
    } else {
      return null;
    }
  },

  getGiftCards(payment) {
    if(payment.gift_cards) {
      return payment.gift_cards.map( c => {
        return {
          paymentObject: c,
          paymentTerms: c.pdv ? 'pdv' : 'gift_card',
          originalTerms: c.pdv ? 'pdv' : 'gift_card',
          amount: c.amount.cents / 100,
          poNumber: c.number,
        }
      })
    } else {
      return [];
    }
  },

  getFormattedAddress(customerAddress) {
    if (!customerAddress || !customerAddress.address) { return {}; }

    const address = customerAddress.address;
    const service = customerAddress.shipping_service;
    let carrier;
    let shippingPriority;
    let shippingCode;
    if (service && service.carrier) {
      carrier = service.carrier;
    }

    if (service && service.name) {
      shippingPriority = service.name;
      shippingCode = service.service_code;
    }

    return {
      company: address.company,
      firstName: address.first_name,
      lastName: address.last_name,
      street1: address.street,
      street2: address.street_2,
      city: address.city,
      region: address.region !== undefined ? address.region : '',
      country: address.country,
      postal_code: address.postal_code,
      phone_number: address.phone_number,
      residential: address.residential,
      carrier,
      shippingPriority,
      shippingCode,
    };
  },
};



// WEBPACK FOOTER //
// /src/helpers/services/workarea.js